import { z } from "zod";

const httpUrlSchema = z
  .string()
  .trim()
  .min(1)
  .max(2000)
  .refine((u) => {
    try {
      const parsed = new URL(u);
      return parsed.protocol === "https:" || parsed.protocol === "http:";
    } catch {
      return false;
    }
  }, "URL must be http(s)");

const colorSchema = z
  .string()
  .trim()
  .regex(/^#[0-9A-Fa-f]{6}$/, "Color must be #RRGGBB");

export const createLaptopSystemSchema = z.object({
  name: z.string().trim().min(1).max(48),
  url: httpUrlSchema,
  color: colorSchema.optional().default("#1E6CC7"),
  description: z.string().trim().max(200).nullable().optional(),
  sortOrder: z.number().int().min(0).max(10_000).optional().default(0),
  isGlobal: z.boolean().optional().default(false),
  active: z.boolean().optional().default(true),
  /** When set, replaces the full assignment list for this system. */
  assignedUserIds: z.array(z.string().min(1)).max(500).optional(),
});

export type CreateLaptopSystemInput = z.infer<typeof createLaptopSystemSchema>;

export const updateLaptopSystemSchema = z
  .object({
    name: z.string().trim().min(1).max(48).optional(),
    url: httpUrlSchema.optional(),
    color: colorSchema.optional(),
    description: z.string().trim().max(200).nullable().optional(),
    sortOrder: z.number().int().min(0).max(10_000).optional(),
    isGlobal: z.boolean().optional(),
    active: z.boolean().optional(),
    assignedUserIds: z.array(z.string().min(1)).max(500).optional(),
  })
  .refine(
    (v) =>
      v.name !== undefined ||
      v.url !== undefined ||
      v.color !== undefined ||
      v.description !== undefined ||
      v.sortOrder !== undefined ||
      v.isGlobal !== undefined ||
      v.active !== undefined ||
      v.assignedUserIds !== undefined,
    { message: "At least one field is required" },
  );

export type UpdateLaptopSystemInput = z.infer<typeof updateLaptopSystemSchema>;
